export const filterAddressesFromSearch = function (addresses, search) {
    if (! addresses || addresses.length < 1) {
        return [];
    }

    const searchQuery = search.toLowerCase();

    return addresses.filter(address => {
        const streetAddress = address.street_address;
        const streetAddressWithApartmentNumber = address.street_address_with_apartment_number;

        return streetAddress.toLowerCase().match(searchQuery)
            || streetAddressWithApartmentNumber.toLowerCase().replace(/\(|\)/g, '').match(searchQuery);
    });
};